import sample_1 from './100_19426.jpg';

export const olympComfortFitImpressions = {
    sample_1,
};
